













































































































import { editFactory } from '@/main/pages';

import { store } from './store/edit';
import { NAME } from './constants';
import { apiProvider } from './api';

export default editFactory(NAME, store).extend({
	computed: {
		IsFirma() {
			return this.PartnertypPzn === 2;
		},
	},
	watch: {
		Text(val) {
			this.titleDetail = val;
		},
	},
	methods: {
		async ChangeToFO() {
			await apiProvider.ChangeToFO(this.ZakaznikkonId);
			this.resetStore();
			this.loadData();
		},
		async ChangeToFirma() {
			await apiProvider.ChangeToFirma(this.ZakaznikkonId);
			this.resetStore();
			this.loadData();
		},
		ChangeToKzv() {},
		loadData() {
			if (this.isCreateMode) {
				// TODO: KUB - Automatika nacitania param.filtru do storu
				this.PartnertypPzn = (this.props.filter as any).PartnertypPzn;
				this.default();
			} else {
				this.entity();
			}
		},
	},
});
